import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf76762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "年", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "組", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditableItemEnum = _resolveComponent("EditableItemEnum")!
  const _component_SearchConditionRadio = _resolveComponent("SearchConditionRadio")!

  return (_openBlock(), _createBlock(_component_SearchConditionRadio, {
    class: "search-condition-popup-class-select-radio-container",
    "data-testid": "class-select-radio",
    "radio-group-name": _ctx.radioGroupName,
    "radio-value": _ctx.radioValue,
    "selected-radio-value": _ctx.selectedRadioValue,
    "on-select": _ctx.onSelectInternal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_EditableItemEnum, {
          class: "input input--school-type",
          "data-testid": "school-type-select",
          value: _ctx.schoolType,
          options: _ctx.schoolTypeOptions,
          editable: true,
          "font-size": 13,
          "on-input": _ctx.onInputSchoolTypeInternal
        }, null, 8, ["value", "options", "on-input"]),
        _createVNode(_component_EditableItemEnum, {
          class: "input input--grade-number",
          "data-testid": "grade-number-select",
          value: _ctx.gradeNumberSelectValue,
          options: _ctx.gradeNumberOptions,
          editable: true,
          "font-size": 13,
          "font-color": "black",
          "on-input": _ctx.onInputGradeNumberInternal
        }, null, 8, ["value", "options", "on-input"]),
        _hoisted_2,
        _createVNode(_component_EditableItemEnum, {
          class: "input input--class",
          "data-testid": "class-name-select",
          value: _ctx.classIdSelectValue,
          options: _ctx.classOptions,
          editable: _ctx.classInputEnabled,
          "font-size": 13,
          "hide-box-on-disable": false,
          "on-input": _ctx.onInputClassInternal
        }, null, 8, ["value", "options", "editable", "on-input"]),
        _hoisted_3
      ])
    ]),
    _: 1
  }, 8, ["radio-group-name", "radio-value", "selected-radio-value", "on-select"]))
}